import { ButtonTs } from '@lt/components';
import styled from 'styled-components';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const StyledUpdatePriceButton = styled<any>(ButtonTs)`
  // повышаем specificity чтобы при многократном использовании компонентов,
  // в разных виджетах на одной странице,
  // первичные стили не перетирали переопределенные
  && {
    font-size: 14px !important;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  padding: 8px 8px 22px 8px;
  background-color: #f3f2e8;
  border-radius: 4px;
  overflow: hidden;
  min-width: 240px;
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    height: 12px;
    width: 53%;
    border-right: 12px solid transparent;
    border-left: 12px solid transparent;
    border-bottom: 12px solid #fff;
  }
`;

export const Title = styled.div`
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Backpack Bold', 'Helvetica', sans-serif;
  font-size: 0.75em;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #8f7344;
`;

export const PriceOutOfDateWrapper = styled.div<{ parentWidth?: number }>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  width: 55%;

  height: 100%;
  display: flex;
  justify-content: flex-end;

  ${({ parentWidth }) => {
    if (
      parentWidth &&
      parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minSm &&
      parentWidth < CONTAINER_QUERY_BREAKPOINTS.minMd
    ) {
      return 'min-width: 186px;';
    }

    return 'min-width: 186px;';
  }}

  &:before {
    content: '';
    z-index: 0;
    position: absolute;
    top: 0;
    left: 32px;
    height: 100%;
    width: 32px;
    background-color: #e8e4c0;
    transform: skew(-15deg);

    ${({ parentWidth }) => {
      if (
        parentWidth &&
        parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minSm &&
        parentWidth < CONTAINER_QUERY_BREAKPOINTS.minMd
      ) {
        return 'left: 57px;';
      }

      return 'left: 32px;';
    }}
  }
`;

export const PriceOutOfDateContent = styled.div<{ parentWidth?: number }>`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;
  position: relative;
  background-color: #e8e4c0;
  height: 100%;
  padding-top: 16px;
  padding-right: 16px;
  width: calc(100% - 50px);
  box-sizing: border-box;
  ${({ parentWidth }) => {
    if (
      parentWidth &&
      parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minSm &&
      parentWidth < CONTAINER_QUERY_BREAKPOINTS.minMd
    ) {
      return 'width: calc(100% - 72px);padding-right: 8px;';
    }

    return 'width: calc(100% - 50px);padding-right: 16px;';
  }}
`;

export const PriceOutOfDate = styled.div`
  display: flex;
  align-items: flex-start;
  width: 118px;
`;

export const PriceOutOfDateText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #919499;
  margin-left: 4px;
`;
